import { MRT_ColumnDef, MRT_Row } from "material-react-table";
import { Box, Switch, Typography } from "@mui/material";
import { BookingProperty } from "../../FacilityManager/Domain/Types/FloorPlan/BookingProperty.type";

const ALL_TYPE_KEYS = ["usedForWorkplace", "usedForZone", "usedForFleet"] as const;
const LABELS: Record<(typeof ALL_TYPE_KEYS)[number], string> = {
  usedForWorkplace: "Workplace",
  usedForZone: "Room",
  usedForFleet: "Drawer_Fleet"
};

export function bookingTypesColumnDef(
  t: (key: string) => string,
  hasFleet = true
): MRT_ColumnDef<BookingProperty> {
  const keys = hasFleet ? ALL_TYPE_KEYS : (["usedForWorkplace", "usedForZone"] as const);
  const labels = LABELS;
  return {
    id: "bookingTypes",
    header: t("_propertiesPerBookingType_typeColumn"),
    size: 320,
    enableEditing: false,
    enableHiding: false,
    Cell: ({ row }: { row: MRT_Row<BookingProperty> }) => (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "center",
          flexWrap: "nowrap"
        }}
      >
        {keys.map(accessorKey => {
          const value = row.original[accessorKey] ?? false;
          return (
            <Box key={accessorKey} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Typography sx={{ fontSize: 14 }}>{t(labels[accessorKey])}</Typography>
              <Switch
                data-testid={`booking-property-${accessorKey}-${row.original.id}`}
                size="small"
                checked={!!value}
                disabled
              />
            </Box>
          );
        })}
      </Box>
    )
  };
}
